module.exports = __webpack_public_path__ + "img/1a.e4e60619.jpg";